const akkordeons = document.querySelectorAll('.akkordeon');

if (akkordeons.length > 0) {
    akkordeons.forEach((item) => {
        item.addEventListener('click', () => {
            item.classList.toggle('active');
        });
    });
}